import { forEachWithGitYield } from '../git/git-runtime.js';
import { gitRenameCurrentBranch } from '../git/branches/rename-branch.js';
import type { LogFn } from '../log.js';

export async function renameSessionWorktreeBranches(
  paths: string[],
  newBranch: string,
  log: LogFn
): Promise<void> {
  const safe = newBranch.replace(/[^a-zA-Z0-9/_-]+/g, '-').slice(0, 80) || 'session-branch';
  await forEachWithGitYield(paths, async (wt) => {
    try {
      await gitRenameCurrentBranch(wt, safe);
      log(`[worktrees] Renamed branch in ${wt} → ${safe}`);
    } catch (e) {
      log(
        `[worktrees] Branch rename failed in ${wt}: ${e instanceof Error ? e.message : String(e)}`,
      );
    }
  });
}
